import Immutable from "immutable";
import { mapArrayToEntity } from "lib/data";

import * as schoolLinked from "lib/appserver/entityHeaders/schoolLinked";

const Message = new Immutable.Record({
  ...schoolLinked.defaultProperties,
  body: undefined,
  sentDate: undefined,
  sender: undefined
}, "Message");
export default Message;

Message.fromAppserver = function buildMessage(rawMessage) {
  return Message({
    body: rawMessage.body,
    sentDate: rawMessage.sent_date,
    sender: rawMessage.sender,
    ...schoolLinked.appserverAdapter(rawMessage)
  })
}

Message.fromAppserverValueList = function buildMessage(valueList) {
  const rawMessage = mapArrayToEntity([
    "appserver_server_hostname",
    "appserver_server_id",
    "appserver_remote_school_id",
    "appserver_remote_entity_id",
    "id",
    "body",
    "sent_date",
    "sender"
  ], valueList);
  return Message.fromAppserver(rawMessage);
}



// WEBPACK FOOTER //
// ./src/state/teachers/entities/Message.js